import { render, staticRenderFns } from "./CostPlanComponent.vue?vue&type=template&id=5fb3b640&"
import script from "./CostPlanComponent.vue?vue&type=script&lang=js&"
export * from "./CostPlanComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports